<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-pen', fontSet: 'fad'}"
	[headerText]="T.CHANGE_SCENARIO_DIALOG_CHANGE_SCENARIO | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		@if (data.scenario) {
			<sim-scenario-chip-input [scenarioFc]="scenarioFormControl" label="Selected Scenario" placeholder="Selected Scenario" />
		}
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="close({action: 'cancel'})"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-times'}"
			[label]="T.BUTTON_CANCEL"
			color="warn"
			style="margin-right: 15px"
		/>

		<sim-button
			(onClick)="changeScenarioClicked()"
			[disabled]="scenarioFormControl.invalid"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.CHANGE_SCENARIO_DIALOG_CHANGE_SCENARIO | translate"
			color="accent"
		/>
	</ng-container>
</sim-basic-material-dialog>
